import styled, { css } from 'styled-components'

export const Container = styled.div(
  ({ theme }) => css`
    display: grid;
    grid-template-columns: 25% 25% 50%;
    padding: ${theme.space['16']} ${theme.space['0']};
  `,
)

export const Row = styled.div(
  ({ theme }) => css`
    padding: ${theme.space['0']} ${theme.space['16']};
  `,
)

export const Divider = styled.div(
  ({ theme }) => css`
    height: 1px;
    background-color: ${theme.colors.gray500};
    margin: ${theme.space['8']} ${theme.space['0']};
  `,
)
